import * as React from 'react';

type Props = Omit<React.HtmlHTMLAttributes<HTMLDivElement>, 'className'>;
/** Hide personally identifiable information from fullstory */
export const HidePii: React.FC<Props> = ({ children, ...divProps }) => {
  return (
    <div className="pii-hide fs-exclude" {...divProps}>
      {children}
    </div>
  );
};
